var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tool-display"},[_c('b',{staticClass:"tool-id"},[_vm._v(_vm._s(_vm.toolId))]),(_vm.showVersion)?_c('span',[_vm._v("@"+_vm._s(_vm.toolVersion))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }